<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        {{'Users_List' | translate}}
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            {{'Users' | translate}}
        </li>
        <li class="breadcrumb-item position-relative">
            {{'Users_List' | translate}}
        </li>
    </ol>
</div>

<!-- Users -->
<mat-card class="daxa-card users-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <app-search-input-with-debouncing (searchEvent)="onSearch($event)"
                placeholder="Search Users"></app-search-input-with-debouncing>
        </mat-card-title>
        @if(hasAccessToAdd){
        <mat-card-subtitle>
            <a mat-button class="add-new-btn" routerLink="/users/add-user">
                + {{'Add New User' | translate}}
            </a>
        </mat-card-subtitle>
        }
    </mat-card-header>
    <mat-card-content>
        <div class="users-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource">
                    <!-- User ID Column -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'User ID' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element?.id }}
                        </td>
                    </ng-container>

                    <!-- FisrstName Column -->
                    <ng-container matColumnDef="ّfullName">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'Full_Name' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-black">
                            <div class="info d-flex align-items-center">
                                <span class="d-block fw-medium">
                                    {{ element?.firstName }} {{ element?.lastName }}
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'Email' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element?.email }}
                        </td>
                    </ng-container>

                    <!-- UserName Column -->
                    <ng-container matColumnDef="userName">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'Username' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-black">
                            {{ element?.username }}
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'Action' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info">
                                <a [routerLink]="['/users/user-details', element.id]">
                                    <button mat-button class="daxa" matTooltip="{{'View' | translate}}"
                                        matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            visibility
                                        </i>
                                    </button>
                                </a>

                                @if(hasAccessToUpdate){
                                <button mat-button class="daxa" (click)="openEditUserDialog(element.id)" mat-button
                                    matTooltip="{{'Edit' | translate}}" matTooltipPosition="above">
                                    <i class="material-symbols-outlined">Edit</i>
                                </button>
                                }
                                <button mat-button class="daxa" mat-button matTooltip="{{'Reset Password' | translate}}"
                                    matTooltipPosition="above" (click)="openResetPasswordDialog(element.id)">
                                    <i class="material-symbols-outlined">
                                        lock_reset
                                    </i>
                                </button>
                                <button mat-icon-button matTooltip="{{'Add Plant' | translate}}" (click)="openPlantEditor(element)">
                                    <mat-icon>energy_savings_leaf</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        @if(isLoading){
                        <td class="mat-cell" colspan="5">
                            <app-buffer-progress-bar></app-buffer-progress-bar>
                        </td>
                        }@else {
                        <td class="mat-cell" colspan="5">
                            No data matching the filter
                        </td>
                        }

                    </tr>
                </table>
            </div>
            <mat-paginator [pageSizeOptions]="[8, 20, 30]" [length]="totalUsers" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>